import type { Transaction } from "@rocicorp/zero";
import { type Schema, zql } from "./generatedDrizzleSchema";
import {
  type PersonalUsePolicy,
  type PersonalUseTarget,
  personalUseBlocked,
} from "./personalUse";
import { userFacingError } from "./userFacingError";

type ReadTransaction = Pick<Transaction<Schema>, "run">;

export async function spacePersonalUseTarget(
  tx: ReadTransaction,
  tenantId: string,
  spaceId: string
): Promise<Extract<PersonalUseTarget, { kind: "space" }>> {
  const [space] = await tx.run(
    zql.spaces.where("id", spaceId).where("tenantId", tenantId)
  );
  if (!space) throw userFacingError("Space not found");
  return { kind: "space", mode: space.mode };
}

export function assertConnectorPersonalUse(
  app: { name: string; personalUse: PersonalUsePolicy | null },
  target: PersonalUseTarget
): void {
  if (personalUseBlocked(app, target)) {
    throw userFacingError(
      `Connector “${app.name}” is not available for personal use`
    );
  }
}
